import { render, staticRenderFns } from "./ChatDetailModal.vue?vue&type=template&id=5e601911&scoped=true&"
import script from "./ChatDetailModal.vue?vue&type=script&lang=js&"
export * from "./ChatDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatDetailModal.vue?vue&type=style&index=0&id=5e601911&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e601911",
  null
  
)

export default component.exports